import { Link } from "react-router-dom";
import { Tv, Camera, Wifi, Building2, Video, Phone } from "lucide-react";

const SERVICES = [
  { icon: Phone, title: "Phone Consultations", desc: "Call in, describe the problem, get a real fix — TVs, remotes, Wi-Fi, printers, phones, smart home." },
  { icon: Video, title: "Video Support Sessions", desc: "Zoom, FaceTime, Google Meet or the free Meeting app. Point your camera at the gear and I'll walk you through it step by step." },
  { icon: Tv, title: "A/V & Home Theater", desc: "Receivers, soundbars, HDMI headaches, streaming boxes and remotes — configured over a call, or installed in your home." },
  { icon: Camera, title: "CCTV & Security Cameras", desc: "Camera apps, doorbells, NVRs, motion alerts and remote viewing tuned over a call — full systems installed in the LA area." },
  { icon: Wifi, title: "Wi-Fi & Networking", desc: "Dead zones, slow speeds, mesh setup, guest networks and devices that won't connect." },
  { icon: Building2, title: "Small Business Consults", desc: "Plan A/V, camera and network systems for your shop or office, plus staff walkthroughs by video." },
];

export function ServicesGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <span className="dg-eyebrow">What we do</span>
          <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold font-display tracking-tight">Any gadget. Any problem. By phone, video or in person.</h2>
        </div>
        <Link to="/services" className="dg-link text-sm" data-testid="services-more">See full services →</Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={s.title} className={`dg-card rounded-xl p-6 dg-reveal dg-reveal-${(i % 4) + 1}`} data-testid={`service-card-${i}`}>
              <div className="w-10 h-10 rounded-lg bg-cyan-500/10 border border-cyan-500/30 grid place-items-center mb-4">
                <Icon className="w-5 h-5 text-cyan-400" />
              </div>
              <div className="font-semibold text-lg">{s.title}</div>
              <p className="text-slate-400 text-sm mt-2 leading-relaxed">{s.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
